
    <mat-icon *ngFor="let i of [1, 2, 3, 4, 5]">
      {{ stars >= i ? 'star' : 'star_border' }}
    </mat-icon>
  